import $ from 'jquery';
window.jQuery = $;
const MobileDetect = require("mobile-detect");
import { initForms } from './modules/forms';
import { initNavigation } from './modules/navigation';
import { initFontAwesome } from './modules/fontAwesome';
import { initSwiper } from './modules/swiper';
import { Equalizer, Reveal } from "foundation-sites";
import { initParallax } from './modules/parallax';
// import { initSlideIn } from './modules/slideIn';
import { initSticky } from './modules/sticky';
// import { initSVGText } from './modules/svgText.js';
import{ initBigText } from './modules/bigText.js';
import{ initTransition } from './modules/transition.js';
import imagesLoaded from 'imagesloaded';
import{ initGallery } from './modules/gallery.js'

var target = window.location.hash,
    target = target.replace('#', '');

// delete hash so the page won't scroll to it
window.location.hash = "";

(($) => {
  'use strict';

// If Foundation modules are installed uncomment this line
$(document).foundation();
var md = new MobileDetect(window.navigator.userAgent);

$(document).ready(() => {

  // imagesLoaded.makeJQueryPlugin( $ );
  imagesLoaded(document.querySelector('.swiper-slide__image'), (elem) => {
    $(elem.elements[0]).addClass('swiper-slide__image--loaded');
});

initBigText(md);
initForms();
initNavigation(md);
initFontAwesome();
initSwiper(md);
initParallax('.swiper-slide__image', '.swiper-slide',md);
initParallax('.teaser-slice__image', '.teaser-slice',md);
initParallax('.buttons-slice-button__image', '.teaser-slice',md);
initSmoothScrolling();
initSticky(md);
initGallery();
// initBigText(md);
// updateSliderHeight();


window.resizeTimeout = setTimeout(fixLayout,500);
$(window).on('resize',function(e){
  if( window.resizeTimeout ) {
    clearTimeout(window.resizeTimeout);
  }
  window.resizeTimeout = setTimeout(fixLayout,500);
});



setTimeout( function(){$('.image-slider__scroll-hint').fadeOut('slow')}, 7000 );

$('.buttons-slice-button').on('click',function(i,e){
  $(e).addClass('hover');
});

});

function fixLayout() {
  initBigText(md);
  $(".image-slider__title").css("opacity",1);
  $(".image-slider__sub-title").css("opacity",1);
  equalizeHeights();
}

/**
 * initiate smooth anchor scrolling
 */
function initSmoothScrolling() {
  if(target) {
    window.scrollTimeOut = setTimeout(function() {
      scrollToAnchor('#' + target);
    }, 1000);

    $(window).scroll(function(){
      clearTimeout(window.scrollTimeOut);
    });

  }
  $("a").on("click", function(event) {
    var link = this.href.split("#")[0];

    var href = window.location.href.split("#")[0];

    // console.log(link,href);
    if (this.hash !== "" && href == link ) {
      event.preventDefault();
      var hash = this.hash;
      scrollToAnchor(hash);
    }
  });
}


  function scrollToAnchor(hash) {

    if (hash == "#top") {
      var endPoint = 0;
    } else {
      var target = $("a[name=" + hash.substring(1) + "]");
      if (target.offset() == undefined) {
        target = $(hash);
      }

      var offset = 0; //130;
      if (md.phone()) {
        //  offset  = 10;
      }

      var endPoint = target.offset().top - offset;
      if (endPoint < 222) {
        endPoint = 0;
      }
    }
    $("html, body").animate({
      scrollTop: endPoint
    }, 600, function(){
      // Add hash (#) to URL when done scrolling (default click behavior)
      window.location.hash = hash;
    });
  }



  function equalizeHeights(){
    $('.equalize').each(function(index,el){

      var h = 0;
      $(el).find('.equalize-watch').each(function(j,el2){
        var item = $(el2);
        item.css('height','auto');
        var item_h = item.height();
        if( h < item_h ){
          h = item_h;
          // console.log(h);
        }
      });

      $(el).find('.equalize-watch').height(h);
    });
  }

  function updateSliderHeight(){
    if (md.phone() ) {
      var h = $(window).height() - 20;
      $(".image-slider").first().height(h);
    }
    if (md.tablet() ) {
      var h = $(window).height() - 30;
      $(".image-slider").first().height(h);
    }
  }

  function updateStaticTitles(){
    var title = $('.image-slider__title')[0];
    var y = parseInt($(title).css('top')) + $(title).outerHeight() - 30;
    $('.image-slider__sub-title').css('top',y);
  }


})(jQuery);
